import { configureStore, createSlice } from "@reduxjs/toolkit";

let commonStore = createSlice({
    name: 'commonStore',
    initialState: {

    },
    reducers: {
        getParseXMLToJSON(state, action) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(action.payload, "text/xml");

            const xmlToJson = (node) => {
                const obj = {};
                if (node.nodeType === 1) { // Element node
                    if (node.attributes.length > 0) {
                        obj["@attributes"] = {};
                        for (let attr of node.attributes) {
                            obj["@attributes"][attr.nodeName] = attr.nodeValue;
                        }
                    }
                } else if (node.nodeType === 3) { // Text node
                    return node.nodeValue.trim();
                }

                if (node.childNodes.length > 0) {
                    for (let child of node.childNodes) {
                        const nodeName = child.nodeName;
                        const jsonChild = xmlToJson(child);

                        if (jsonChild) {
                            if (obj[nodeName] === undefined) {
                                obj[nodeName] = jsonChild;
                            } else {
                                if (!Array.isArray(obj[nodeName])) {
                                    obj[nodeName] = [obj[nodeName]];
                                }
                                obj[nodeName].push(jsonChild);
                            }
                        }
                    }
                }                
                return obj;
            };            

            return { [xmlDoc.documentElement.nodeName]: xmlToJson(xmlDoc.documentElement) };
        }
    }
});
let privateData = createSlice({
    name: 'privateData',
    initialState: {
        kakaoKey: '252789b38c66bb62dc7212f1c1176ea0',
        serviceKey: 'WH3rCrAO12XZos%2B%2BZ4%2FQrU2BnN60h8kdMHU%2FPgbBi3anKDHcWL03M7okYqUKv6bG%2FyajxPRKKVDNW9P3FJddbw%3D%3D'
    }
});

let hospital = createSlice({
    name: 'hospital',
    initialState : {
        hpId : '',        
        hospitalEmergencyUrl: 'https://apis.data.go.kr/B552657/ErmctInfoInqireService/getEmrrmRltmUsefulSckbdInfoInqire',        
        hospitalDissUrl: 'https://apis.data.go.kr/B552657/ErmctInfoInqireService/getSrsillDissAceptncPosblInfoInqire',
        hospitalUrl:'https://apis.data.go.kr/B552657/ErmctInfoInqireService/getEgytBassInfoInqire'
    },
    reducers: {
        setHpId(state, action) {
            let hpId = action.payload;
            state.hpId = hpId;
        }
    }
});

let medicine = createSlice({
    name: 'medicine',
    initialState : {
        medicineUrl: 'https://apis.data.go.kr/1471000/DrbEasyDrugInfoService/getDrbEasyDrugList'
    },
    reducers: {

    }
});

let pharmacy = createSlice({
    name: 'pharmacy',
    initialState: {
        pharmacyWgsUrl: 'https://apis.data.go.kr/B552657/ErmctInsttInfoInqireService/getParmacyLcinfoInqire'
    }
})

let fineDust = createSlice({
    name:'fineDust',
    initialState: {
        fineDustUrl: 'https://apis.data.go.kr/B552584/ArpltnInforInqireSvc/getMinuDustFrcstDspth'
    },
    reducers: {

    }
});

export let {setHpId} = hospital.actions;
export let {getParseXMLToJSON} = commonStore.actions;

export default configureStore({
    reducer: {
        commonStore : commonStore.reducer,
        hospital: hospital.reducer,
        privateData: privateData.reducer,
        medicine: medicine.reducer,
        fineDust: fineDust.reducer,
        pharmacy: pharmacy.reducer        
    }
});